import { flow } from 'lodash';
import AccordionGroup from './AccordionGroup';
import withUserInput from '../../hocs/UserInput';
import withPager from '../../hocs/Pager';

export default flow(withUserInput, withPager)(AccordionGroup);



// WEBPACK FOOTER //
// ../core/src/components/AccordionGroup/index.js